/* Amavil · Afeitadora 2 en 1 — landing interactions (prefix af2-) */
(function () {
  'use strict';
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  /* ---------- GALLERY ---------- */
  function initGallery(root){
    var track=root.querySelector('.af2-gallery-track');
    if(!track) return;
    var slides=track.querySelectorAll('.af2-gslide');
    if(slides.length<=1) return;
    var dots=root.parentNode.querySelectorAll('.af2-dot');
    var thumbs=root.parentNode.querySelectorAll('.af2-thumb');
    var i=0, n=slides.length;
    function go(k){
      i=(k+n)%n;
      track.style.transform='translateX(-'+(i*100)+'%)';
      dots.forEach(function(d,x){d.classList.toggle('is-active',x===i);});
      thumbs.forEach(function(t,x){t.classList.toggle('is-active',x===i);});
    }
    var prev=root.querySelector('.af2-gallery-arrow.prev');
    var next=root.querySelector('.af2-gallery-arrow.next');
    if(prev) prev.addEventListener('click',function(){go(i-1);});
    if(next) next.addEventListener('click',function(){go(i+1);});
    dots.forEach(function(d,x){d.addEventListener('click',function(){go(x);});});
    thumbs.forEach(function(t,x){t.addEventListener('click',function(){go(x);});});
    var x0=null;
    root.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    root.addEventListener('touchend',function(e){
      if(x0===null) return;
      var dx=e.changedTouches[0].clientX-x0;
      if(Math.abs(dx)>40){ go(dx<0?i+1:i-1); }
      x0=null;
    },{passive:true});
    go(0);
  }

  /* ---------- VIDEO CAROUSEL ---------- */
  function initVideoCarousel(root){
    var track=root.querySelector('.af2-vid-track');
    if(!track) return;
    var cells=track.querySelectorAll('.af2-vid-cell');
    var n=cells.length; if(n<=1){ return; }
    var idx=0;
    function perView(){ return window.innerWidth>=768?3:1; }
    function maxIdx(){ return Math.max(0,n-perView()); }
    function basis(){ return 100/perView(); }
    function render(){
      if(idx>maxIdx()) idx=maxIdx();
      if(idx<0) idx=0;
      track.style.transform='translateX(-'+(idx*basis())+'%)';
    }
    var pv=root.querySelector('.af2-vid-arrow.prev');
    var nx=root.querySelector('.af2-vid-arrow.next');
    if(pv) pv.addEventListener('click',function(){ idx=idx<=0?maxIdx():idx-1; render(); });
    if(nx) nx.addEventListener('click',function(){ idx=idx>=maxIdx()?0:idx+1; render(); });
    window.addEventListener('resize',render);
    render();
  }

  /* ---------- REVIEWS CAROUSEL ---------- */
  function initReviews(root){
    var track=root.querySelector('.af2-rev-track');
    if(!track) return;
    var cells=track.querySelectorAll('.af2-rev-cell');
    var n=cells.length; if(!n) return;
    var dotsWrap=root.querySelector('.af2-rev-dots');
    var idx=0, timer=null, paused=false;
    function perView(){ var w=window.innerWidth; return w>=968?3:(w>=640?2:1); }
    function maxIdx(){ return Math.max(0, n-perView()); }
    function basis(){ return 100/perView(); }
    function render(){
      if(idx>maxIdx()) idx=maxIdx();
      track.style.transform='translateX(-'+(idx*basis())+'%)';
      buildDots();
    }
    function buildDots(){
      if(!dotsWrap) return;
      var count=maxIdx()+1;
      dotsWrap.innerHTML='';
      for(var d=0; d<count; d++){
        (function(d){
          var b=document.createElement('button');
          b.type='button'; b.className='af2-rev-dot'+(d===idx?' is-active':'');
          b.setAttribute('aria-label','Ir a reseña '+(d+1));
          b.addEventListener('click',function(){idx=d;render();});
          dotsWrap.appendChild(b);
        })(d);
      }
    }
    function nextR(){ idx=idx>=maxIdx()?0:idx+1; render(); }
    function prevR(){ idx=idx<=0?maxIdx():idx-1; render(); }
    var pv=root.querySelector('.af2-rev-arrow.prev');
    var nx=root.querySelector('.af2-rev-arrow.next');
    if(pv) pv.addEventListener('click',prevR);
    if(nx) nx.addEventListener('click',nextR);
    root.addEventListener('mouseenter',function(){paused=true;});
    root.addEventListener('mouseleave',function(){paused=false;});
    window.addEventListener('resize',render);
    timer=setInterval(function(){ if(!paused) nextR(); },5500);
    render();
  }

  /* ---------- STICKY BAR + BACK TO TOP ---------- */
  function initSticky(){
    var sticky=document.querySelector('.af2-sticky');
    var top=document.querySelector('.af2-top');
    var buy=document.getElementById('producto');
    var footer=document.querySelector('footer');
    if(!sticky && !top) return;
    function onScroll(){
      var y=window.scrollY, vh=window.innerHeight;
      var docH=document.documentElement.scrollHeight;
      // Appear only AFTER roughly half the page has been scrolled. Hidden on load (y=0).
      var past = y > 200 && y > ((docH - vh) * 0.5);
      var footerIn = footer ? (footer.getBoundingClientRect().top < vh-20) : false;
      if(sticky) sticky.classList.toggle('is-visible', past && !footerIn);
      if(top){
        top.classList.toggle('is-visible', y>400);
        top.classList.toggle('raised', past && !footerIn);
      }
    }
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});
    window.addEventListener('load',onScroll);
    onScroll();
    if(sticky){
      var sb=sticky.querySelector('.af2-sticky-btn');
      if(sb) sb.addEventListener('click',function(){
        if(buy) window.scrollTo({top:buy.getBoundingClientRect().top+window.scrollY-110,behavior:'smooth'});
      });
    }
    if(top) top.addEventListener('click',function(){ window.scrollTo({top:0,behavior:'smooth'}); });
  }

  ready(function(){
    document.querySelectorAll('.af2-gallery').forEach(initGallery);
    document.querySelectorAll('.af2-videos').forEach(initVideoCarousel);
    document.querySelectorAll('.af2-rev-view').forEach(initReviews);
    initSticky();
  });
})();
